var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.061,
    height: 21.828,
    viewBox: "0 0 22.061 21.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    d: "M17,3a2.828,2.828,0,0,1,4,4L7.5,20.5,2,22l1.5-5.5Z",
    transform: "translate(-1 -1.172)",
    fill: "none",
    stroke: "#94a2b8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIcon);
export default __webpack_public_path__ + "static/media/update_icon.da52c8b7.svg";
export { ForwardRef as ReactComponent };